import { createAction } from 'redux-actions'

export const muteRemoteAudio = createAction<number>('MUTE_REMOTE_AUDIO')
export const onAudioMuted = createAction<void>('ON_AUDIO_MUTED')
export const muteAudio = createAction<void>('MUTE_AUDIO')
export const onRemoteAudioMuted = createAction<[{ value: string }]>('ON_REMOTE_AUDIO_MUTED')
export const onMuteAudioProgressStateUpdate = createAction<boolean>('ON_MUTE_AUDIO_PROGRESS_STATE_UPDATE')
export const updateRemoteAudioIndicator = createAction<number>('UPDATE_REMOTE_AUDIO_INDICATOR')
